import { OperationHandler } from '../types';
import { BooleanOperationPayload } from './types';

export function useIsOperation(payload: BooleanOperationPayload): OperationHandler {
  return (attribute: boolean) => ({ isValid: attribute === payload.boolean });
}
